import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";
import { BrowserRouter, useNavigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./app/store";
import { LineupProvider } from "./context/LineupContext";
import { ToastProvider } from "./context/ToastContext";
import ToastContainer from "./components/toast/ToastContainer";
import Loading from "./components/common/Loading";
import Auth0Binder from "./auth/Auth0Binder";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Treat data as fresh for 60s so remounts/navigation don't refetch every
      // time, and stop the tab-focus refetch storm. Real-time data uses sockets.
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      retry: 2,
    },
  },
});

const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN;
const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID;

// Wrapper component to access navigate inside BrowserRouter
const Auth0ProviderWithNavigate = ({ children }) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState) => {
    navigate(appState?.returnTo || window.location.pathname, { replace: true });
  };

  return (
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens={true}
      useRefreshTokensFallback={true}
      authorizationParams={{
        audience: "https://api.dayshiftsports.com",
        scope: "openid profile email offline_access",
        redirect_uri: window.location.origin,
      }}
    >
      {children}
    </Auth0Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0ProviderWithNavigate>
        <Auth0Binder />
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <PersistGate loading={<Loading />} persistor={persistor}>
              <ToastProvider>
                <ToastContainer />
                <LineupProvider>
                  <App />
                </LineupProvider>
              </ToastProvider>
            </PersistGate>
          </Provider>
        </QueryClientProvider>
      </Auth0ProviderWithNavigate>
    </BrowserRouter>
  </React.StrictMode>
);
